// components
import Modal from "../Modal";
// images
import orderSuccess from "../../../../assets/images/orderSuccess.png";
// config
import { dashboardLink } from "../../../../axios/axios";

const OrderSuccessModal = (props) => {
  const okClickedHandler = () => {
    props.close();
  };

  return (
    <Modal close={props.close}>
      <div className="flex flex-col items-center gap-6">
        <img
          src={orderSuccess}
          alt="order success placement"
          className="w-20 h-20"
        />
        <h3 className="text-center">تم وضع طلبك بنجاح</h3>
        <h4>رقم الطلب : {props.orderId}</h4>
        <div className="mt-4 flex flex-wrap w-full gap-4 justify-center px-12">
          <a
            href={dashboardLink.concat(`/order/${props.orderId}/accept`)}
            target="_blank"
            rel="noreferrer"
            className="bg-dark-blue text-white text-sm font-bold py-3 px-6 rounded"
          >
            لتتبع طلبك اضغط هنا
          </a>

          <button
            className="bg-light-gray text-sm font-bold py-3 px-6 rounded"
            onClick={okClickedHandler}
          >
            إغلاق
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderSuccessModal;
